module.exports = __webpack_public_path__ + "static/gothic-a1-v8-latin-700-a7cd0ec85a3df82fb29b7bf79b157b74.woff2";